module.exports = __webpack_public_path__ + "static/media/Instructions2.a4c0dede.png";